/**
 * WhatDoYouSeePromo — homepage teaser block driving traffic to /what-do-you-see.
 * Small, premium, high-contrast — designed to live alongside Truth Of The Week
 * without competing with it.
 */
import { Link } from "react-router-dom";
import { Eye, ArrowRight } from "lucide-react";

export default function WhatDoYouSeePromo() {
  return (
    <section className="bg-[#050505] py-14 md:py-20 border-t border-white/5" data-testid="wdys-promo">
      <div className="max-w-[1480px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 items-center bg-gradient-to-br from-[#0c0a08] to-[#050505] border border-[#C9A055]/20 p-8 md:p-12">
          {/* Left: copy */}
          <div className="lg:col-span-7">
            <div className="font-ui text-[11px] tracking-[0.32em] text-[#C9A055] inline-flex items-center gap-2">
              <Eye size={13}/> AN EXPERIENCE
            </div>
            <h2 className="font-display text-3xl md:text-5xl text-[#F4F1EA] mt-4 leading-[1.05]">
              What Do You See?
            </h2>
            <p className="font-body text-[#B5B0A7] mt-5 leading-relaxed max-w-xl">
              Before we tell you what each piece means to us, we want to know what it says to you. Look first. Feel first. Read last.
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link to="/what-do-you-see" className="btn-gold inline-flex items-center gap-2" data-testid="wdys-promo-cta">
                Start The Experience <ArrowRight size={14}/>
              </Link>
            </div>
            <p className="font-body text-[11px] text-[#6a6660] mt-4 italic">
              A different artwork every time. Your interpretation is saved privately for the artist.
            </p>
          </div>

          {/* Right: visual */}
          <div className="lg:col-span-5">
            <div className="relative aspect-square border border-[#C9A055]/30 bg-black flex items-center justify-center overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-[#C9A055]/10 via-transparent to-[#C9A055]/5"/>
              <Eye size={120} className="text-[#C9A055]/70" strokeWidth={1.1}/>
              <div className="absolute bottom-4 left-4 right-4 text-center">
                <div className="font-script text-[#C9A055] text-2xl">Look first.</div>
                <div className="font-script text-[#C9A055] text-2xl">Read last.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
